import React from "react";
import { I18n, Translate as T } from "react-redux-i18n";
import Overlay from "../Overlay/Overlay";
import Dialog from "../Dialog/Dialog";

import styles from "./About.css";

const About = ({ show, hideAbout }) => (
  <Overlay show={show}>
    <div className={styles.about}>
      <Dialog onClose={hideAbout} heading={I18n.t("about.heading")}>
        <div className={styles.wrapper}>
          <T value="about.body" link={window.location} dangerousHTML />
        </div>
      </Dialog>
    </div>
  </Overlay>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About/About.js